import Navbar from '@/components/feature/Navbar';
import ContactFooter from '@/pages/home/components/ContactFooter';
import RegisterHero from './components/RegisterHero';
import RegisterProcess from './components/RegisterProcess';
import RegisterForm from './components/RegisterForm';

export default function RegisterPage() {
  return (
    <div className="min-h-screen w-full">
      <Navbar />
      <main>
        <RegisterHero />
        <RegisterForm />
        <RegisterProcess />
      </main>
      <ContactFooter />
    </div>
  );
}
